import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/inspection-dashboard')({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <>
      <Outlet />
    </>
  )
}
